export default __webpack_public_path__ + "static/media/storm-4.16ac8884.png";